/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegrationDto } from '../../models/integration-dto';
import { UpdateIntegrationDto } from '../../models/update-integration-dto';

export interface IntegrationsControllerUpdate$Params {
  storeId: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
  body: UpdateIntegrationDto;
}

export function integrationsControllerUpdate(
  http: HttpClient,
  rootUrl: string,
  params: IntegrationsControllerUpdate$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<IntegrationDto>> {
  const rb = new RequestBuilder(rootUrl, integrationsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntegrationDto>;
    })
  );
}

integrationsControllerUpdate.PATH = '/api/v1/integrations/{storeId}';
